import React, { useRef, useState } from 'react'
import { Box, Typography, Button as ButtonMui, Radio, RadioGroup, FormControlLabel, TextField } from '@material-ui/core'
import { Button } from 'components'
import { usePopup } from 'hooks/usePopup'
import { separationOrderService } from 'services/separationOrderService'
import { BreakOrder } from 'interfaces/IBreakOrder'
import { Loading } from 'pages/Admin/Breaks/styles'

import { IModalOrderCanceled, ModalOrderCanceled } from '../ModalOrderCanceled'
import {
  ButtonCancel,
  ButtonConfirm,
  Container,
  ContainerButtons,
  InfoCostumer,
  Modal,
  TextAlert,
  TextConfirmAddBoxes,
  TextConfirmRelease,
  Title,
} from './styles'

interface IModalConfirmOrderLoad {
  open: boolean
  handleClose: () => void
  order: BreakOrder
  pollingBreak: (isError: boolean, isRefresh: boolean) => Promise<void>
}

export const ModalConfirmLoad = ({
  handleClose,
  order,
  pollingBreak,
  open,
}: IModalConfirmOrderLoad) => {
  const controllerOrder = new AbortController()

  const { addPopup } = usePopup()
  const [isLoading, setIsLoading] = useState(false)
  const modalOrderCanceledRef = useRef<IModalOrderCanceled>(null)
  const [additionalBoxes, setAdditionalBoxes] = useState<'sim' | 'não' | null>(null)
  const [boxesQuantity, setBoxesQuantity] = useState<string>('')
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false)

  const handleAdditionalBoxesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as 'sim' | 'não'
    setAdditionalBoxes(value)
    setIsConfirmEnabled(value === 'não')
    setBoxesQuantity('')
  }

  const handleBoxesQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setBoxesQuantity(value)
    setIsConfirmEnabled(Number(value) > 0)
  }

  const onClose = () => {
    setAdditionalBoxes(null)
    setBoxesQuantity('')
    setIsConfirmEnabled(false)
    handleClose()
  }

  const handleConfirm = async () => {
    try {
      setIsLoading(true)
      await separationOrderService.confirmOrderLoad(
        order.order_id,
        controllerOrder,
        Number(boxesQuantity),
      )
      await pollingBreak(false, true)
      onClose()
      addPopup({
        type: 'success',
        title: 'Pedido liberado com sucesso',
      })
    } catch (error: any) {
      if (error?.message === 'This order has been canceled') {
        modalOrderCanceledRef.current?.onOpen()
        return
      }
      addPopup({
        type: 'error',
        title: 'Ocorreu um erro',
        description: error?.message || error,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Modal open={open}>
        <Container>
          <Loading loading={isLoading} />
          <Title>Liberar pedido</Title>
          <InfoCostumer>
            <p>
              Cliente: <strong>{order.client_name}</strong>
            </p>
            <p>
              N° Pedido: <strong>{order.order_id}</strong>
            </p>
            <p>
              Itens com quebras: <strong>{order.runouts.length}</strong>
            </p>
          </InfoCostumer>
          {order.is_order_separated ? (
            <>
              <TextConfirmAddBoxes>Adicionou mais caixas?</TextConfirmAddBoxes>
              <Box display="flex" justifyContent="center">
                <RadioGroup row value={additionalBoxes} onChange={handleAdditionalBoxesChange}>
                  <FormControlLabel value="sim" control={<Radio />} label="Sim" />
                  <FormControlLabel value="não" control={<Radio />} label="Não" />
                </RadioGroup>
              </Box>

              {additionalBoxes === 'sim' && (
                <TextField
                  type="number"
                  label="Quantidade de caixas adicionadas"
                  value={boxesQuantity}
                  onChange={handleBoxesQuantityChange}
                  inputProps={{ min: 1 }}
                  style={{ width: '80%', marginBottom: '1rem' }}
                />
              )}
              <TextConfirmRelease>Confirmar a liberação desse pedido?</TextConfirmRelease>
              <ContainerButtons>
                <ButtonCancel onClick={onClose} disabled={isLoading}>
                  Cancelar
                </ButtonCancel>
                <ButtonConfirm onClick={handleConfirm} disabled={isLoading || !isConfirmEnabled}>
                  Confirmar
                </ButtonConfirm>
              </ContainerButtons>
            </>
          ) : (
            <>
              <TextAlert>
                <strong>
                  O Pedido tá em separação. Adicionou caixas? Não esqueça de avisar o(a) separador(a).
                </strong>
              </TextAlert><ContainerButtons>
                <ButtonConfirm onClick={onClose}>Beleza!</ButtonConfirm>
              </ContainerButtons>
                </>
          )}
        </Container>
      </Modal>
      <ModalOrderCanceled
        orderId={order.order_id}
        clientName={order.client_name}
        callback={onClose}
        ref={modalOrderCanceledRef}
      />
    </>
  )
}
